import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import { Image } from "@heroui/image";
import { Link } from "@heroui/link";

import Nav from "./Nav/Nav";

const Header = () => {
  // State to track if mobile navigation menu is open/closed
  const [navActive, setNavActive] = useState(false);

  return (
    // Absolute positioning: header overlays content, positioned 40px from top
    // z-[60]: High z-index to ensure header stays above other content
    <header className="absolute top-10 left-0 right-0 z-60">
      <div className="container mx-auto">
        <div className="flex justify-between items-center px-4 xl:px-0">
          {/* Logo - Links to home page */}
          <Link
            className="relative w-25 h-10 xl:w-30 xl:h-10 z-60"
            href="#home"
            onClick={(e) => {
              e.preventDefault();
              setNavActive(false);
              document
                .getElementById("home")
                ?.scrollIntoView({ behavior: "smooth" });
            }}
          >
            {/* Using Heroui Image for consistency, or standard img if preferrable for logo to avoid wrapper issues inside Link */}
            <Image
              alt="Zenbrew Logo"
              className="object-contain w-full h-full"
              height={80}
              src="/assets/logo.webp"
            />
          </Link>

          {/* Hamburger Menu Button - Animated 3-line to X transformation */}
          <button
            aria-label="Toggle navigation menu" // Accessibility
            className="w-8 h-6 text-accent relative flex items-center justify-center z-60 outline-none"
            onClick={() => setNavActive(!navActive)} // Toggle menu state
          >
            {/* Top line - rotates 45deg to form X when active */}
            <span
              className={`w-full h-[1.5px] bg-current absolute left-0 will-change-transform transition-transform duration-300 ${
                navActive ? "top-1/2 rotate-45" : "top-0 translate-y-0"
              }`}
            />
            {/* Middle line - fades out when menu is active */}
            <span
              className={`w-full h-[1.5px] bg-current absolute left-0  transition-opacity duration-300 ${
                navActive ? "opacity-0" : "top-1/2"
              }`}
            />
            {/* Bottom line - rotates -45deg to form X when active */}
            <span
              className={`w-full h-[1.5px] bg-current absolute left-0 will-change-transform transition-transform duration-300 ${
                navActive ? "top-1/2 -rotate-45" : "bottom-0 translate-y-0"
              }`}
            />
          </button>
        </div>
      </div>

      {/* Navigation Menu - Conditionally rendered with AnimatePresence for exit animations */}
      {/* mode="wait" ensures exit animation completes before enter animation */}
      <AnimatePresence mode="wait">
        {navActive && <Nav closeNav={() => setNavActive(false)} />}
      </AnimatePresence>
    </header>
  );
};

export default Header;
